<template>
    <section class="section-wrapp">
        <Breadcrumbs :parameters=breadcrumbs></Breadcrumbs>
        <UsersTable></UsersTable>
    </section>
</template>

<script>
import UsersTable from '@/components/users/UsersTable.vue'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  name: 'Users',
  components: {
    UsersTable, Breadcrumbs
  },
  data () {
    return {
      message: '',
      breadcrumbs: [
        {
          url: '#',
          title: 'Users'
        }
      ]
    }
  },
  computed: {
    isLoading () {
      return this.$store.getters[ 'users/isLoading' ]
    },
    hasError () {
      return this.$store.getters[ 'users/hasError' ]
    },
    error () {
      return this.$store.getters[ 'users/error' ]
    },
    hasUsers () {
      return this.$store.getters[ 'users/hasPosts' ]
    },
    users () {
      return this.$store.getters[ 'users/users' ]
    },
    stations () {
      return this.$store.getters[ 'users/stations' ]
    }
  },
  created () {
    this.$store.dispatch('users/findAll')
    this.$store.dispatch('users/unsetCurrent')
  },
  methods: {
    async createUser () {
      const result = await this.$store.dispatch('users/create', this.$data.message)
      if (result !== null) {
        this.$data.message = ''
      }
    }
  }
}
</script>
